import { PortalProvider } from "@gorhom/portal";
import { useFonts } from "expo-font";
import React, { useCallback, useMemo } from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Route, Routes } from "react-router";
import { Aurora } from "@lookiero/aurora";
import { Body } from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { themeByTradename } from "@lookiero/sty-psp-ui";
import { apiUrl, kameleoonConfig, Root, styleProfileBootstrap, styleProfileSentryConfig } from "./SharedBootstrap";
import { nextBestActionRoot } from "./infrastructure/ui/integration/nextBestAction/NextBestActionRoot";
import { Router } from "./infrastructure/ui/routing/router/Router";
import {
  OnNextBestActionCompletedFunction,
  OnNextBestActionNavigateToStyleProfileFunction,
  OnNextBestActionPressCta,
  OnNextBestActionReadyFunction,
} from "./infrastructure/ui/views/nextBestAction/NextBestActionScreen";

const ExpoRootNextBestAction: Root = ({ customer, tradename, locale, getAuthToken }) => {
  const [fontsLoaded] = useFonts({
    ["AreaInktrap-Semibold"]: require("@lookiero/aurora/build/assets/fonts/AreaInktrap-Semibold.otf"),
    ["AreaNormal-Semibold"]: require("@lookiero/aurora/build/assets/fonts/AreaNormal-Semibold.otf"),
    ["AreaNormal-Extrabold"]: require("@lookiero/aurora/build/assets/fonts/AreaNormal-Extrabold.otf"),
    ["OpenSans-Regular"]: require("@lookiero/aurora/build/assets/fonts/OpenSans-Regular.ttf"),
    ["OpenSans-Bold"]: require("@lookiero/aurora/build/assets/fonts/OpenSans-Bold.ttf"),
    auroraicons: require("@lookiero/aurora-iconfont/dist/auroraicons.ttf"),
  });

  const theme = useMemo(() => themeByTradename({ tradename }), [tradename]);

  const { Component: Messaging } = useMemo(
    () => styleProfileBootstrap({ apiUrl: () => apiUrl, getAuthToken }),
    [getAuthToken],
  );

  const { NextBestActionRootHost, NextBestActionRoot } = useMemo(
    () =>
      nextBestActionRoot({
        Messaging,
        development: true,
        sentry: () => styleProfileSentryConfig,
        kameleoon: () => kameleoonConfig,
        apiUrl: () => apiUrl,
        getAuthToken,
      })({
        customerId: customer.customerId,
      }),
    [customer.customerId, getAuthToken, Messaging],
  );

  const handleOnReady: OnNextBestActionReadyFunction = useCallback(({ actions }) => {
    console.log(`READY - ${actions} actions`);
  }, []);
  const handleOnCompleted: OnNextBestActionCompletedFunction = useCallback(() => {
    console.log("COMPLETED");
  }, []);
  const handleOnNavigateToStyleProfile: OnNextBestActionNavigateToStyleProfileFunction = useCallback(() => {
    console.log("Navigate to style-profile");
  }, []);
  const handleOnPressCta: OnNextBestActionPressCta = useCallback(() => {
    console.log("CTA pressed - Navigate to home");
  }, []);

  return fontsLoaded ? (
    <SafeAreaProvider>
      <PortalProvider>
        <NextBestActionRootHost>
          <Aurora theme={theme}>
            <Router>
              <Routes>
                <Route
                  path="*"
                  element={
                    <Body>
                      <NextBestActionRoot
                        customer={customer}
                        locale={locale}
                        tradename={tradename}
                        onCompleted={handleOnCompleted}
                        onNavigateToStyleProfile={handleOnNavigateToStyleProfile}
                        onPressCta={handleOnPressCta}
                        onReady={handleOnReady}
                      />
                    </Body>
                  }
                />
              </Routes>
            </Router>
          </Aurora>
        </NextBestActionRootHost>
      </PortalProvider>
    </SafeAreaProvider>
  ) : null;
};

export { ExpoRootNextBestAction };
